import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "HttpClient";

export const getAllData = (parameter: any) => {
  return HttpClient().post(`${apiRoutes.PGXLis.LisSetting.GetAll}`, parameter);
};

export const UpdateData = (parameter: any) => {
  return HttpClient().post(`${apiRoutes.PGXLis.LisSetting.Update}`, parameter);
};
